import { makeVar } from "@apollo/client";
import type { G_VideoSeasonType, G_VideoDownloadFile, G_VideoContentType, Maybe, G_GetVideoQuery } from "~/lib/graphql";

export type DownloadModalData = {
  /** 作品名 */
  titleName: string;
  /** シーズン種別 */
  seasonType: G_VideoSeasonType;
  /** 品質毎のダウンロードファイル情報 */
  downloadableFiles: Maybe<G_VideoDownloadFile[]> | undefined;
  /**
   * コンテンツ種別
   * - シーズン種別が「VideoLegacySeason」の場合のみ指定する
   * - 「VideoLegacySeason」の場合「2D/VR」でUIの出し分けを行う必要があるから
   */
  contentType?: G_VideoContentType;
};
type InitialState = {
  clickedContentId: string;
  downloadModalData: DownloadModalData | undefined;
  isLoadingAPI: boolean;
  isOpenDownloadModal: boolean;
  isOpenProductModal: boolean;
  isOpenPurchaseModal: boolean;
  isOpenReviewModal: boolean;
  isOpenSampleViewModal: boolean;
  isOpenAffiliateModal: boolean;
  isWakuwakuContent: boolean;
  isFirstFocusPurchasedTab: boolean;
  itemVariant: string | undefined;
  productId: string;
  productDetail: G_GetVideoQuery | undefined;
  modalReactiveWidth: number;
};

export const initialState: InitialState = {
  clickedContentId: "",
  downloadModalData: undefined,
  isLoadingAPI: true,
  isOpenDownloadModal: false,
  isOpenProductModal: false,
  isOpenPurchaseModal: false,
  isOpenReviewModal: false,
  isOpenSampleViewModal: false,
  isOpenAffiliateModal: false,
  isWakuwakuContent: false,
  isFirstFocusPurchasedTab: false,
  itemVariant: undefined,
  productId: "",
  productDetail: undefined,
  modalReactiveWidth: 0,
};

export const clickedContentIdVar = makeVar(initialState.clickedContentId);
export const downloadModalDataVar = makeVar(initialState.downloadModalData);
export const isLoadingAPIVar = makeVar(initialState.isLoadingAPI);
export const isOpenDownloadModalVar = makeVar(initialState.isOpenDownloadModal);
export const isOpenProductModalVar = makeVar(initialState.isOpenProductModal);
export const isOpenPurchaseModalVar = makeVar(initialState.isOpenPurchaseModal);
export const isOpenAffiliateModalVar = makeVar(initialState.isOpenAffiliateModal);
export const isOpenReviewModalVar = makeVar(initialState.isOpenReviewModal);
export const isOpenSampleViewModalVar = makeVar(initialState.isOpenSampleViewModal);
export const isWakuwakuContentVar = makeVar(initialState.isWakuwakuContent);
export const isFirstFocusPurchasedTabVar = makeVar(initialState.isFirstFocusPurchasedTab);
export const itemVariantVar = makeVar(initialState.itemVariant);
export const productIdVar = makeVar(initialState.productId);
export const productDetailVar = makeVar(initialState.productDetail);
export const modalReactiveWidthVar = makeVar(initialState.modalReactiveWidth);

export const resetAllProductState = () => {
  clickedContentIdVar(initialState.clickedContentId);
  downloadModalDataVar(initialState.downloadModalData);
  isLoadingAPIVar(initialState.isLoadingAPI);
  isOpenDownloadModalVar(initialState.isOpenDownloadModal);
  isOpenProductModalVar(initialState.isOpenProductModal);
  isOpenPurchaseModalVar(initialState.isOpenPurchaseModal);
  isOpenAffiliateModalVar(initialState.isOpenAffiliateModal);
  isOpenReviewModalVar(initialState.isOpenReviewModal);
  isOpenSampleViewModalVar(initialState.isOpenSampleViewModal);
  isWakuwakuContentVar(initialState.isWakuwakuContent);
  itemVariantVar(initialState.itemVariant);
  productIdVar(initialState.productId);
  productDetailVar(initialState.productDetail);
  modalReactiveWidthVar(initialState.modalReactiveWidth);
};
